export default "__VITE_ASSET__DOjwXIti__"